module.exports = __webpack_public_path__ + "static/media/helix-ultra.4a6a4231.png";